import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import SectionHeader from 'components_v2/common/SectionHeader';
import EtimesTabs from 'components_etimes/common/Tabs/EtimesTabs';
import MoreButton from 'components_library/molecules/MoreButton/MoreButton';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import makeRequest from '../../../utils/makeRequest';
import LoaderSpinner from '../../../components_v2/common/LoaderSpinner/LoaderSpinner';

const ListView = ({
  item,
  s,
  isPrime,
  showLoadMoreStories,
  loadMoreCallback = () => {},
  moreText,
  isPhotostoryList,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [itemsLoaded, setItemsLoaded] = useState([]);
  const [activeTabPath, setActiveTabPath] = useState('');
  const [activeTab, setActiveTab] = useState(
    Array.isArray(item.subSections) && item.subSections.length
      ? item.subSections[0].name
      : '',
  );

  const settings = {
    dots: true,
    slidesToShow: item.slidesToShow || 4,
    slidesToScroll: item.slidesToScroll || 1,
    infinite: item?.infinite || false,
    centerMode: item?.centerMode || false,
    className: item?.centerMode ? 'center' : '',
  };

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const loadSectionData = async (dataUrl, path) => {
    if (!dataUrl) return;
    if (isPrime) dataUrl += '&pc1=yes';
    setIsLoading(true);
    try {
      const { data } = await makeRequest.get(dataUrl, {}, 'skipfeedengine');
      if (data?.items?.length) {
        setItemsLoaded(data.items);
      }
      setActiveTabPath(path || item.path);
    } catch (error) {
      console.error('Error loading section data:', error);
      setActiveTabPath(path || item.path);
    } finally {
      setIsLoading(false);
    }
  };

  const onTabsChange = ({ clickedItem }) => {
    if (clickedItem?.dataUrl) {
      loadSectionData(clickedItem.dataUrl, clickedItem.path);
    }
    if (clickedItem?.name) {
      setActiveTab(clickedItem.name);
    }
  };

  const itemsToRender = itemsLoaded.length > 0 ? itemsLoaded : item.items;
  const containerClass =
    (item &&
      item.classNames &&
      Array.isArray(item.classNames) &&
      item.classNames.map(i => s[i]).join(' ')) ||
    '';

  return (
    <div className={containerClass}>
      {isLoading && <LoaderSpinner />}
      {item?.name && (
        <SectionHeader
          title={item?.name}
          icon={item.icon}
          path={activeTabPath || item.path}
          sponseredText={item.sponser?.sponseredText}
          sponseredLogo={item.sponser?.sponseredLogo}
          sponseredLink={item.sponser?.sponseredLink}
          ga4Type={item.ga4Type}
        >
          {item.subSections?.length > 0 && (
            <div className={s.tabContainer}>
              <span className={s.line} />
              <EtimesTabs
                tabs={item.subSections}
                ga4Type={item.ga4Type}
                onChangeCallback={onTabsChange}
                active={activeTab}
              />
            </div>
          )}
        </SectionHeader>
      )}
      {!item.withoutSlick || item.withoutSlick === 'false' ? (
        <div className="slick_UI smallArrow smallArrowBlack dark_theme">
          <Slider {...settings}>
            {itemsToRender &&
              Array.isArray(itemsToRender) &&
              itemsToRender.map(it => (
                <ErrorBoundary key={it.msid || it.id}>
                  <NewStoryCard
                    {...it}
                    msid={it.msid || it.id}
                    wu={item.ga4Type === 'books_slider' ? '' : it.wu}
                    title={it.hl}
                    cardType={item.cardType || it.tn}
                    iconClass={item?.theme || it.iconClass || 'videoshowIcon'}
                    ga4Type={item.ga4Type}
                  />
                </ErrorBoundary>
              ))}
          </Slider>
        </div>
      ) : (
        <div
          className={
            (item.innerClassNames &&
              Array.isArray(item.innerClassNames) &&
              item.innerClassNames?.map(i => s[i]).join(' ')) ||
            ''
          }
        >
          {itemsToRender &&
            Array.isArray(itemsToRender) &&
            itemsToRender.map(it => (
              <ErrorBoundary key={it.msid || it.id}>
                <NewStoryCard
                  {...it}
                  des={item?.doNotShowDesc ? '' : it.des}
                  msid={
                    item.toiVideoFeedFormat === '1' ? it.id : it?.msid || it?.id
                  }
                  wu={item.ga4Type === 'books_slider' ? '' : it.wu}
                  title={it.hl}
                  syn={item?.synopsis || it?.synopsis}
                  cardType={item.cardType || it.tn}
                  iconClass={item?.theme || it.iconClass || 'videoshowIcon'}
                  ga4Type={item.ga4Type}
                  isPhotostoryList={isPhotostoryList}
                />
              </ErrorBoundary>
            ))}
        </div>
      )}
      {showLoadMoreStories && (
        <MoreButton
          isNoLink
          onClick={loadMoreCallback}
          typeSchemaClasses="w_0"
          moreText={moreText || 'Load More'}
        />
      )}
    </div>
  );
};

export default ListView;
